import { useTranslation } from 'react-i18next';
import korArmy1 from '../../assets/images/customer_logo/kor_army1.svg';
import korArmy3 from '../../assets/images/customer_logo/kor_army3.svg';
import rebellions from '../../assets/images/customer_logo/rebellions.svg';
import didim365 from '../../assets/images/customer_logo/didim365.svg';

const partnersLogos = [
  { src: korArmy1, key: '0' },
  { src: korArmy3, key: '1' },
  { src: rebellions, key: '2' },
  { src: didim365, key: '3' },
];

export default function PartnersSection() {
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <section className="py-[100px] bg-white text-center w-full max-w-[1280px] mx-auto px-6">
      <div className="w-full max-w-[1280px] mx-auto flex flex-col items-center">
        <h3 className="text-2xl md:text-4xl font-bold text-center mb-[100px]">
          {t('Partners.title')}
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 sm:gap-16 md:gap-12 place-items-center">
          {partnersLogos.map((logo, index) => {
            const description = t(`Partners.partnersList.${logo.key}.description`);
            const hasDescription = description && description.trim() !== '';

            return (
              <div
                key={index}
                className={`relative flex justify-center items-center group ${hasDescription ? 'hover-effect' : ''}`}
              >
                <img
                  src={logo.src}
                  alt={t(`Partners.partnersList.${logo.key}.name`)}
                  className={`w-auto max-h-16 md:max-h-20 max-w-36 sm:max-w-40 md:max-w-44 object-contain transition-opacity duration-300 ${
                    hasDescription ? 'group-hover:opacity-20' : ''
                  }`}
                />
                {hasDescription && (
                  <span className="absolute inset-0 flex items-center justify-center font-bold text-sm md:text-base text-black px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {description}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
